import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { TableComponent } from '../../../../../shared/components/table/table.component';
import { FieldValue } from '../../../../../shared/constants/services.enum';

@Component({
  selector: 'app-information-request-list',
  imports: [ReactiveFormsModule, TranslateModule, TableComponent],
  templateUrl: './information-request-list.component.html',
  styleUrl: './information-request-list.component.scss'
})
export class InformationRequestListComponent implements OnInit, OnChanges, OnDestroy {
  @Input() form!: FormGroup;
  @Input() accountServiceRequests: any[] = [];
  @Input() accountServiceRequestsLoading: boolean = false;
  @Output() selectionChange = new EventEmitter<any>();

  searchCooNumber = new FormControl('');
  currentPage: number = 1;
  pageSize: number = 5;
  private searchSubscription?: Subscription;

  // This method is used to initialize the class instance
  constructor() { }

  ngOnInit(): void {
    this.subscribeToSearchChanges();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['accountServiceRequests'] && !changes['accountServiceRequests'].firstChange) {
      this.currentPage = 1;
    }
  }

  ngOnDestroy(): void {
    this.searchSubscription?.unsubscribe();
  }

  get showAccountServiceRequests() {
    return this.shouldLoadAccountServiceRequests();
  }

  private subscribeToSearchChanges(): void {
    this.searchSubscription?.unsubscribe();
    this.searchSubscription = this.searchCooNumber.valueChanges.subscribe(() => {
      this.currentPage = 1;
    });
  }

  private shouldLoadAccountServiceRequests(): boolean {
    const enquiryType = this.form?.get('enquiryType')?.value;
    const letterType = this.form?.get('letterType')?.value;
    const isCertificateAmendment =
      enquiryType === FieldValue.ENQUIRY_TYPE_CERTIFICATE_AMENDMENT ||
      enquiryType === FieldValue.ENQUIRY_TYPE_CERTIFICATE_AMENDMENT_AR;
    const isFreeMarketing =
      letterType === FieldValue.FREE_MARKETING_CERTIFICATE ||
      letterType === FieldValue.FREE_MARKETING_CERTIFICATE_AR;
    return isCertificateAmendment && isFreeMarketing;
  }

  onPageChange(page: number) {
    this.currentPage = page;
  }

  get filteredRequests() {
    const term = this.searchCooNumber.value?.toString().trim().toLowerCase();
    if (!term) {
      return this.accountServiceRequests;
    }
    return this.accountServiceRequests.filter((row: any) => {
      const candidates = [
        row?.['SR Number'],
        row?.['DC COO Number'],
        row?.['DC Created']
      ];
      return candidates.some((value: any) =>
        value != null && value.toString().toLowerCase().includes(term)
      );
    });
  }

  get paginatedRequests() {
    const start = (this.currentPage - 1) * this.pageSize;
    return this.filteredRequests.slice(start, start + this.pageSize);
  }

  applyAccountServiceRequest(row: any) {
    if (!row) {
      return;
    }
    // const cooNumber = row?.['DC COO Number'] ?? row?.['COO Number'] ?? row?.['DC COO No'] ?? row?.['COO No'];
    // if (!cooNumber) {
    //   return;
    // }
    // const control = this.form?.get('cooNumber');
    // control?.setValue(cooNumber);
    // control?.markAsDirty();
    // control?.markAsTouched();
    this.selectionChange.emit(row);
  }

}
